import PropTypes from 'prop-types';
import { Button, DetailedIconPaperAirplane, Divider, Flex, Heading, ModalDialog } from '@zillow/constellation';
import LeasesPaymentsUpsell from '../../LeasesPaymentsUpsell';
import StyledParagraph from '../components/StyledParagraph';
import StyledHeading from '../components/StyledHeading';
import { applicationApprovedHeader } from '../InviteToMoveInManagerUtil';

function InviteToMoveInConfirmationModal({ isOpen, onClose, isIncomeToRentEligible = false }) {
  function closeConfirmationModal() {
    onClose();
  }

  return (
    <ModalDialog
      wide
      {...{
        isOpen,
        onClose: closeConfirmationModal,
        mediaQuery: {
          xs: { fullScreen: true },
          md: { fullScreen: false },
        },
        header: <Heading level={4}>{applicationApprovedHeader}</Heading>,
        body: (
          <div className="zon_InviteToMoveInConfirmation__Body">
            <Flex
              display="flex"
              flexDirection="column"
              alignItems="center"
              paddingX={{ default: 'xs', md: 'xl', xl: 10 }}
            >
              <DetailedIconPaperAirplane status="success" size="lg" marginTop="sm" marginBottom="xs" />
              <StyledHeading fontFamily="serif" level={4} marginBottom="sm">
                Your message was sent
              </StyledHeading>
              <StyledParagraph marginBottom="md">
                While you wait for the applicant to accept, you can get a head start on creating a lease (or upload one
                you've already prepared) and setting up payments.
              </StyledParagraph>
              <Divider marginY="sm" />
              <LeasesPaymentsUpsell isInModal />
            </Flex>
          </div>
        ),
        footer: isIncomeToRentEligible && (
          <Button
            buttonType="primary"
            onClick={closeConfirmationModal}
            fluid={{ default: true, md: false }}
            paddingX={{ default: 0, md: 6 }}
          >
            OK
          </Button>
        ),
      }}
    />
  );
}

InviteToMoveInConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isIncomeToRentEligible: PropTypes.bool,
};

export default InviteToMoveInConfirmationModal;
